import axios from 'axios'
const { VITE_APP_ENV, VITE_APP_VERSION } = import.meta.env

// 版本监控
export const versionCheckUpdate = async (isRefresh = true) => {
  const versionUrl = `/version.json?_t=${new Date().getTime()}`
  const localKey = `RECHARGE_APP_${VITE_APP_ENV}_VERSION`
  console.log(versionUrl, 'versionUrl')
  const headers = {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '-1'
  }
  // if (VITE_APP_ENV === 'dev') return
  let res = null
  try {
    res = await axios.get(versionUrl, { headers })
  } catch (error) {
    // 获取版本异常了 强制reload
    window.location.reload()
    console.log(error, '获取版本异常了')
  }
  let nextVersion = null
  if (res) {
    nextVersion = res.data[`${VITE_APP_ENV}_version`]
  }
  const localVersion = localStorage.getItem(localKey)
  console.log(VITE_APP_VERSION, localVersion, nextVersion)
  if (nextVersion && Number(localVersion) !== nextVersion) {
    localStorage.setItem(localKey, nextVersion)
    console.log('提示reload 出问题')
    if (isRefresh) window.location.reload()
    return nextVersion
  }
  localStorage.setItem(localKey, nextVersion || '')
  return nextVersion
}

// 基于vite的变量做版本跟新
export const viteAppCheckUpdate = () => {
  const localKey = `RECHARGE_APP_${VITE_APP_ENV}_VERSION`
  console.log(localKey, 'localKey')
  console.log(VITE_APP_VERSION, 'VITE_APP_VERSION')

  if (VITE_APP_ENV === 'dev') return

  // const localVersion = localStorage.getItem(localKey)
  // console.log(localVersion, 'localVersion')
  // if (VITE_APP_VERSION !== localVersion) {
  //   console.log('版本号不配', VITE_APP_VERSION)
  //   localStorage.setItem(localKey, VITE_APP_VERSION)
  //   window.location.reload()
  // }
}
